import { Component, OnInit, ViewChild, HostListener } from '@angular/core';

import * as _ from 'lodash';

import { ButtonComponent } from '../../../button/index';
import { Dialog, DialogRef, DialogParams, DialogStringFunction } from '../../../dialog/dialog.base';

/**
 * @ignore
 */
@Component({
  selector: 'uex-dialog-confirm',
  templateUrl: './confirm.component.html'
})
export class DialogConfirmComponent implements OnInit {
  @ViewChild('confirmButton', { static: true }) private _confirmButton: ButtonComponent;
  @ViewChild('confirmButtonReverted', { static: true }) private _confirmButtonReverted: ButtonComponent;
  @ViewChild('rejectButton', { static: true }) private _rejectButton: ButtonComponent;
  @ViewChild('rejectButtonReverted', { static: true }) private _rejectButtonReverted: ButtonComponent;

  @HostListener('document:keydown', ['$event']) onKeydown(e: KeyboardEvent) {
    const keyCode = e.which || e.keyCode;
    switch (keyCode) {
      case 37:  // Arrow left
        e.preventDefault();
        this._decreaseActiveButtonIndex();
        break;
      case 9:   // Tab
        e.preventDefault();
        if (e.shiftKey) this._decreaseActiveButtonIndex();
        else this._increaseActiveButtonIndex();
        break;
      case 39:  // Arrow right
        e.preventDefault();
        this._increaseActiveButtonIndex();
        break;
      case 13:  // Return
      case 32:  // Space
        e.preventDefault();
        this._selectActiveButton();
        break;
      case 27:  // Escape
        e.preventDefault();
        this.reject();
      default:
        return;
    }
  }

  constructor(
    private _dialogRef: DialogRef,
    private _dialogParams: DialogParams
  ) {
    this.dialog = this._dialogRef.dialog;
  }

  public dialog: Dialog;

  private _active_button_index: number = 1;
  private _buttons: Array<ButtonComponent> = [];
  private _reverted_buttons: Array<ButtonComponent> = [];

  public ngOnInit() {
    this._buttons = [
      this._rejectButton,
      this._confirmButton
    ];
    this._reverted_buttons = [
      this._rejectButtonReverted,
      this._confirmButtonReverted
    ];
    this._active_button_index = 1;
    this._focusActiveButton(true);
  }

  public get headerClass(): string {
    return this._dialogParams.get('headerClass');
  }

  public get title(): string {
    return this._dialogParams.get('title');
  }

  public get titleClass(): string {
    return this._dialogParams.get('titleClass');
  }

  public get subtitle(): string {
    return this._dialogParams.get('subtitle');
  }

  public get subtitleClass(): string {
    return this._dialogParams.get('subtitleClass');
  }

  public get message(): string {
    return this._dialogParams.get('message');
  }

  public get footerClass(): string {
    return this._dialogParams.get('footerClass');
  }

  public get revertButtonOrder(): boolean {
    let revert_button_order: boolean = this._dialogParams.get('revertButtonOrder');
    return revert_button_order ? revert_button_order : false;
  }

  public get resolveButtonText(): string {
    let button_text: DialogStringFunction | string = this._dialogParams.get('resolveButtonText');
    if(_.isFunction(button_text)) {
      button_text = (<DialogStringFunction>button_text)();
    }
    return button_text ? (<string>button_text) : 'Ok';
  }

  public get resolveButtonMode(): string {
    let button_mode: string = this._dialogParams.get('resolveButtonMode');
    return button_mode ? button_mode : 'clear';
  }

  public get resolveButtonColor(): string {
    let button_color: string = this._dialogParams.get('resolveButtonColor');
    return button_color ? button_color : 'primary';
  }

  public get rejectButtonText(): string {
    let button_text: DialogStringFunction | string = this._dialogParams.get('rejectButtonText');
    if(_.isFunction(button_text)) {
      button_text = (<DialogStringFunction>button_text)();
    }
    return button_text ? (<string>button_text) : 'Cancelar';
  }

  public get rejectButtonMode(): string {
    let button_mode: string = this._dialogParams.get('rejectButtonMode');
    return button_mode ? button_mode : 'clear';
  }

  public get rejectButtonColor(): string {
    let button_color: string = this._dialogParams.get('rejectButtonColor');
    return button_color ? button_color : 'red';
  }

  public resolve() {
    this.dialog.returnValue(true);
  }

  public reject() {
    this.dialog.returnValue(false);
  }

  private _decreaseActiveButtonIndex() {
    const buttons = this.revertButtonOrder ? this._reverted_buttons : this._buttons;
    if(buttons.length == 0) return;
    this._active_button_index = this._active_button_index == (buttons.length-1) ? 0 : this._active_button_index + 1;
    this._focusActiveButton();
  }

  private _increaseActiveButtonIndex() {
    const buttons = this.revertButtonOrder ? this._reverted_buttons : this._buttons;
    if (buttons.length == 0) return;
    this._active_button_index = this._active_button_index == 0 ? (buttons.length-1) : this._active_button_index - 1;
    this._focusActiveButton();
  }

  private _selectActiveButton() {
    switch(this._active_button_index) {
      case 0:
        return this.reject();
      case 1:
      default:
        return this.resolve();
    }
  }

  private _focusActiveButton(has_delay: boolean = false) {
    const buttons = this.revertButtonOrder ? this._reverted_buttons : this._buttons;
    buttons[this._active_button_index].focus(has_delay);
  }
}
